



























































import Vue from "vue";
import { proxyModel } from "@/common/utils/proxyModel";
import PromotionGroupRowPrice from "./PromotionGroupRowPrice.vue";
import {
  PromotionConditionPriceForm,
  PromotionItemGroupForm
} from "../forms/PromotionCreateForm";

export default Vue.extend({
  components: {
    PromotionGroupRowPrice
  },
  props: {
    value: {
      type: Object as () => PromotionConditionPriceForm,
      default: () => {
        return { price: 0, promotionItemGroups: [{ items: [] }] };
      }
    },
    placeholder: {
      type: String,
      default: ""
    },
    isLoading: {
      type: Boolean
    },
    isDisable: {
      type: Boolean
    },
    validations: {
      type: Object
    }
  },
  computed: {
    ...proxyModel("price", "promotionItemGroups", "deletedPromotionGroupsId"),
    priceError() {
      return (this as any).validations.price.$error
        ? "ช่วงราคา is required or invalid"
        : "";
    }
  },
  methods: {
    remove() {
      this.$emit("remove");
      this.$emit("removePromotionGroup");
    },
    checkItem() {
      this.$emit("checkItem");
    },
    addPromotionItemGroup() {
      (this as any).promotionItemGroups = [
        ...(this as any).promotionItemGroups,
        { items: [], deletedItemsId: [] }
      ];
    },
    updatePromotionItemGroup(
      promotionItemGroup: PromotionItemGroupForm,
      index: number
    ) {
      (this as any).promotionItemGroups = (this as any).promotionItemGroups.map(
        (e: any, i: any) => {
          return i === index ? promotionItemGroup : e;
        }
      );
    },
    removePromotionItemGroup(index: number) {
      (this as any).promotionItemGroups = (this as any).promotionItemGroups.filter(
        (_: any, i: any) => {
          return i !== index;
        }
      );
    },
    addRemovePromotionItemGroup(id: number) {
      if (id) {
        (this as any).deletedPromotionGroupsId.push(id);
      }
    }
  }
});
